import React from "react";
import { GiftIcon, RefreshCwIcon, SearchIcon, MicroscopeIcon, ZapIcon, BoxIcon } from "lucide-react";
import { differentiators } from "../data/content";
import { DifferentiatorIcon } from "../types/content";
const ICONS: Record<DifferentiatorIcon, BoxIcon> = {
  microscope: MicroscopeIcon,
  search: SearchIcon,
  zap: ZapIcon,
  gift: GiftIcon,
  refresh: RefreshCwIcon
};
export function Differentiators() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-30" data-mp="zdskvvwzlw0h">
      <div className="mx-auto max-w-2xl text-center" data-id="element-31" data-mp="13ecif0lh31n5">
        <h2 className="font-display text-[1.2rem] font-bold uppercase leading-tight text-navy sm:text-[1.7rem]" data-id="element-32" data-mp="13f451lx3dp1a">
          THIS ISN'T JUST ANOTHER SURGICAL INSTRUMENT EBOOK
        </h2>
        <p className="mt-0.5 font-heading text-[0.76rem] font-extrabold uppercase tracking-wide text-clinical sm:text-[0.92rem]" data-id="element-33" data-mp="1ddjs9dt00e5i">
          IT'S A READY-TO-USE VISUAL STUDY SYSTEM.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-34" data-mp="2oqvzlynyvewf">
          {differentiators.map((item, i) => {
          const Icon = ICONS[item.icon];
          const isLastOdd = i === differentiators.length - 1 && differentiators.length % 2 === 1;
          return <div key={item.title} className={`rounded-md border border-navy/10 bg-mist px-2.5 py-2 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-35" data-mp="2o5r0vj7sinp" data-mpi={i}>
                <h3 className="flex items-center gap-1.5 font-heading text-[0.78rem] font-extrabold text-navy sm:text-[0.9rem]" data-id="element-36" data-mp="3ttdwi6fyisss">
                  <Icon className="h-3.5 w-3.5 shrink-0 text-clinical" strokeWidth={2.25} aria-hidden="true" data-id="element-37" data-mp="3ownhznjsw59h" />
                  {item.title}
                </h3>
                <p className="mt-0.5 text-[0.76rem] leading-[1.35] sm:text-[0.86rem]" data-id="element-38" data-mp="3g28zzd7vygmo">{item.body}</p>
              </div>;
        })}
        </div>
        <p className="mt-2 font-heading text-[0.74rem] font-extrabold uppercase tracking-wide text-navy sm:text-[0.88rem]" data-id="element-39" data-mp="3b1uthzlxneqr">
          Less scattered studying. Less confusion. <span className="text-clinical" data-id="element-40" data-mp="316t7hcmyesse">More visual clarity.</span>
        </p>
      </div>
    </section>;
}